import { API, tokenKey, areaForPath } from "@/lib/api";

const VID_KEY = "gp_vid", SID_KEY = "gp_sid", SID_TS = "gp_sid_ts";
const uuid = () => (window.crypto?.randomUUID ? window.crypto.randomUUID() : `${Date.now()}-${Math.random().toString(16).slice(2)}`);

function visitorId() {
  let v = localStorage.getItem(VID_KEY);
  if (!v) { v = uuid(); localStorage.setItem(VID_KEY, v); }
  return v;
}

function sessionId() {
  const now = Date.now();
  const last = Number(sessionStorage.getItem(SID_TS) || 0);
  let s = sessionStorage.getItem(SID_KEY);
  if (!s || now - last > 30 * 60 * 1000) { s = uuid(); sessionStorage.setItem(SID_KEY, s); }
  sessionStorage.setItem(SID_TS, String(now));
  return s;
}

function utm() {
  const p = new URLSearchParams(window.location.search);
  return { utm_source: p.get("utm_source") || "", utm_medium: p.get("utm_medium") || "", utm_campaign: p.get("utm_campaign") || "" };
}

let mountTs = Date.now();

export function track(type, path) {
  try {
    const body = JSON.stringify({
      session_id: sessionId(), visitor_id: visitorId(), type,
      path: path || window.location.pathname,
      referrer: document.referrer || "", ...utm(),
      dwell_ms: Date.now() - mountTs,
    });
    const url = `${API}/analytics/track`;
    if (type === "end" && navigator.sendBeacon) {
      navigator.sendBeacon(url, new Blob([body], { type: "application/json" }));
      return;
    }
    const token = localStorage.getItem(tokenKey(areaForPath(window.location.pathname)));
    fetch(url, {
      method: "POST", keepalive: true,
      headers: { "Content-Type": "application/json", ...(token ? { Authorization: `Bearer ${token}` } : {}) },
      body,
    }).catch(() => {});
  } catch { /* analytics must never break the app */ }
}

export function trackPageview(path) { mountTs = Date.now(); track("pageview", path); }
export function trackBooking() { track("book"); }
